import { useUser } from "@platform/store";
import { useChat, useChatActions, useTalkJSData } from "@platform/hooks/useChat";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useFetchUserCircles } from "@core/features/circle";
import { ChatSheet } from "./ChatSheet";

export function ChatSheetContainer() {
  const { isOpen } = useChat();
  const { closeChat } = useChatActions();
  const talkjsData = useTalkJSData();
  const user = useUser();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;

  const { shouldShowChat, isLoading: isChatStatusLoading } = useChatVisibility({
    userCircles,
  });

  // Don't render chat sheet if chat is disabled or missing required data
  if (!isChatStatusLoading && !shouldShowChat) {
    return null;
  }

  // Don't render if required data is missing
  if (!talkjsData || !user) {
    return null;
  }

  return (
    <ChatSheet
      isLoading={isChatStatusLoading}
      isOpen={isOpen}
      onClose={closeChat}
      talkjsData={talkjsData}
      user={user}
    />
  );
}

export default ChatSheetContainer;


